export default __webpack_public_path__ + "static/media/errorpokemon.eff32e71.gif";